import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { map, filter } from 'ramda';

import { formatDate } from 'lib/dateDisplay';
import { localizeArray } from 'lib/l18nUtils';

import { createSummaryTile } from '../containers/SummaryLoaderContainer';
import TileRow from './TileRow';

import { path } from 'routes/Documents/routes/Relapse';

import icon from '../assets/relapses.svg';
import { dateFromPartial, isPartialDate } from 'neuro-utils';

const opt = o => (o ? `relapse.opts.${o}` : null);

const predicate = d => d.relapseDate && d.relapseSymptoms;

const View = ({ localeMessage, data = [] }) => (
  <Grid fluid>
    {map(d => (
      <TileRow
        key={d.documentId}
        title={formatDate(isPartialDate(d.relapseDate) ? dateFromPartial(d.relapseDate) : d.relapseDate)}
      >
        <p className="bold">{localizeArray(localeMessage, d.relapseSymptoms, opt)}</p>
      </TileRow>
    ))(filter(predicate, data))}
  </Grid>
);

View.propTypes = {
  localeMessage: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default createSummaryTile(View, { module: 'relapse', localeId: 'relapse.title', routeTo: path, icon });
